<template>
	<div
		:class="['c-drop-catcher', { active: active === true }]"
		@drop="onDrop"
		@dragenter.prevent
		@dragover.prevent
	></div>
</template>


<script>
export default {
	data: function () {
		return {
			active: false,
		};
	},
	methods: {
		receiveMessage: function (event) {
			console.log(event.data);
			let obj;
			try {
				obj = JSON.parse(event.data);
			} catch (err) {
				console.log('probably dragstart');
			}

			if (obj && obj.mouse) {
				console.log(obj);
				const syntheticEvent = new DragEvent('drop');
				// Override dataTransfer first so we can define our own.
				Object.defineProperty(syntheticEvent, 'dataTransfer', {
					value: {},
				});
				// Once dataTransfer is overridden, you can define getData.
				syntheticEvent.dataTransfer.getData = (dragFormatRequested) => {
					// only handling text atm.
					if (['text', 'text/html'].indexOf(dragFormatRequested) > -1) {
						return obj.textPayload;
					}
				};
				const target = document.elementFromPoint(obj.mouse.x, obj.mouse.y);
				Object.defineProperty(syntheticEvent, 'target', {
					value: target,
				});
				target.dispatchEvent(syntheticEvent);
			}
		},
		onDrop: function (e) {
			e.preventDefault();
			this.parseDataTransfer(e);
		},
		parseDataTransfer: function (e) {
			let dataTransfer = e.dataTransfer;
			let payload = {};
			for (var i = 0; i < dataTransfer.types.length; i++) {
				if (dataTransfer.types[i] === 'text/plain') {
					payload.text = dataTransfer.getData(dataTransfer.types[i]);
				}
				if (dataTransfer.types[i] === 'text/html') {
					payload.html = dataTransfer.getData(dataTransfer.types[i]);
				}
			}

			let data = {
				id: 'underlineme',
				type: 'data',
				mouse: {
					x: e.clientX,
					y: e.clientY,
				},
				payload: payload,
				url: window.location.href,
			};
			this.$emit('catch', data);
		},
	},
	mounted: function () {
		window.addEventListener('dragstart', (e) => {
			//console.log('start');
			//console.log(this);
			this.active = true;
		});
		window.addEventListener('drag', (e) => {
			if (this.active) {
				let data = {
					id: 'underlineme',
					type: 'drag',
					mouse: {
						x: e.clientX,
						y: e.clientY,
					},
				};
				this.$emit('move', data);
			}
		});
		window.addEventListener('dragend', (e) => {
			//console.log(e);
			if (this.active) {
				this.active = false;
				let data = {
					id: 'underlineme',
					type: 'dragend',
				};
				this.$emit('dragend', data);
			}
		});
		window.addEventListener('drop', (e) => {});
	},
};
</script>

<style lang="scss">
.c-drop-catcher {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;

	&.active {
		pointer-events: all;
		background-color: rgba($primary, 0.1);
	}
}
</style>